// Export all the page data objects
export const homePageData = {
    hero: {
        titleLine1: "We Provide The Best Products",
        titleLine2: "& Solutions",
        subtitle: "Your trusted technology partner for innovative, reliable, and future-ready solutions tailored to elevate your business.",
        mainButtonText: "Discover More",
        mainButtonLink: "about",
        backgroundImage: "/images/banner.png"
    },
    partners: [
        { id: 1, alt: "Partner 1", src: "/images/partner_1.png" },
        { id: 2, alt: "Partner 2", src: "/images/partner_2.png" },
        { id: 3, alt: "Partner 3", src: "/images/partner_3.png" },
    ],
    solutionsSection: {
        title: "We Are Products and Solutions Provider for Your Applications",
        description: "JIOTRONIK offers comprehensive solutions, leveraging years of expertise in understanding customer needs and industrial demands. Our passion is to introduce innovative technology for end-users, built on strong engineering and scientific principles.",
        imageSrc: "/images/products_solutions.png",
        points: [
            { title: "Committed to Deadline", icon: "🏆" },
            { title: "Team Work", icon: "🤝" }
        ],
        ctaButtonLink: "about",
    },
    valueToCustomer: {
        title: "Value To The Customer",
        subtitle: "We prioritize delivering exceptional value through quality, reliability, and dedicated support, ensuring your success is our success.",
        values: [
            { title: "10+ Years Of Experience", desc: "Leveraging a decade of industry knowledge to serve you better.", icon: "🌟" },
            { title: "Best Quality Products", desc: "Ensuring top-notch quality in every product we deliver.", icon: "💎" },
            { title: "On Time Delivery", desc: "Committed to timely delivery to meet your project schedules.", icon: "⏱️" }
        ],
        ctaButtonText: "Get A Quote",
        ctaButtonLink: "contact"
    },
    bestServices: {
        title: "We Provide Best Services",
        services: [
            { title: "Product Development", desc: "Innovative product design and development tailored to your needs.", icon: "💡" },
            { title: "Technical Support", desc: "Reliable and prompt technical assistance for all our solutions.", icon: "🛠️" },
            { title: "Software Development", desc: "Custom software solutions to optimize your operations.", icon: "💻" }
        ],
        ctaButtonText: "View All Services",
        ctaButtonLink: "products",
        ctaButtonLink2: "contact"
    },
    emergencyServices: {
        title: "We Are Available For Emergency Services 24/7",
        subtitle : "We're Ready Anytime",
        ctaButtonText: "Contact Us Now",
        ctaButtonLink: "contact"
    },
    philosophy: {
        title: "Our Philosophy",
        description: "At Jiotronik, our philosophy is rooted in innovation, customer satisfaction, and a commitment to excellence. We believe in building long-term partnerships by delivering reliable and cutting-edge solutions that drive progress.",
        imageSrc: "/images/products_solutions.png",
        points: [
            "Customer-centric approach",
            "Continuous innovation",
            "Unwavering quality and reliability",
            "Integrity and transparency in all dealings"
        ]
    }
};

export const aboutUsPageData = {
    pageTitle: "About Jiotronik",
    breadcrumbs: "Home > About Us",
    imageSrc: "/images/about1.png",
    sectionTitle: "About Jiotronik",
    headline: "We Are Products and Solutions Provider for Your Applications",
    description1: "JIOTRONIK, products and solutions provider, has over the years built a strong foundation of understanding customer needs and the specific and industrial fraternity. Our passion is to introduce innovative technology in the market for the benefit of end-users. We build and offer solutions understanding engineering and scientific principles.",
    description2: "Our deep understanding of Engineering and scientific principles, coupled with a relentless customer-centric approach, establishes JIOTRONIK as a trusted and forward-thinking solution partner.",
    keyPoints: [
        { title: "Committed to Deadline", description: "We meticulously plan and execute to meet every client's deadline with precision.", icon: "🏆" },
        { title: "Team Work", description: "Our collaborative spirit ensures that collective expertise drives impactful results.", icon: "🤝" }
    ],
    coreAreasTitle: "Our Core Areas:",
    coreAreas: [
        "State-of-the-Art Products",
        "Bespoke Client Services",
        "Advanced Software Solutions",
        "Comprehensive Automation Systems"
    ]
};

export const instrumentationAutomationProductsPageData = {
    pageTitle: "Instrumentation & Automation",
    breadcrumbs: "Home > Products > Instrumentation & Automation",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "WEIGHBRIDGE SYSTEM",
            img: "/images/products/instrumentation/wireless-weignscale.webp",
            desc: "It is built around the idea to exploit maximum functionality which can make Weighbridge operations effortless.",
            pdfUrl: "/data/instrumentation/WEIGHBRIDGE-INDICATOR.pdf"
        },
        {
            name: "CATALOGUE",
            img: "/images/products/instrumentation/CATALOGUE.webp",
            desc: "It is built around the idea to exploit maximum functionality which can make Weighbridge operations effortless.",
            pdfUrl: "/data/instrumentation/CATALOGUE.pdf"
        },
        {
            name: "DATA LOGGER FOR M2M COMMUNICATION",
            img: "/images/products/instrumentation/Datalogger.webp",
            desc: "An Intelligent Active GPRS/GPS Remote Terminal Unit for robust M2M communications.",
            pdfUrl: "/data/instrumentation/DATA-LOGGER-FOR-M2M-APPLICATION.pdf"
        },
        {
            name: "HOOK OR HANGING WEIGHING INDICATOR",
            img: "/images/products/instrumentation/hook.webp",
            desc: "The product is Hook or Hanging scale, shows/indicates current weight applied on the Hook.",
            pdfUrl: "/data/instrumentation/HOOK-OR-HANGING-SCALE-WITH-INDICATOR.pdf"
        },
        {
            name: "DIGITAL LOADCELL INDICATOR SUMMING & DUAL TYPE",
            img: "/images/products/instrumentation/Digital-Load-cell-compression-cup-and-ball-type.webp",
            desc: "Digital Loadcell Indicator or Summing Card is useful where more than one loadcell signal to be...",
            pdfUrl: "/data/instrumentation/DIGITAL-LOADCELL-COMPRESSION-CUPBALL-TYPE.pdf"
        },
        {
            name: "BAG MAKING PLC WITH 7 INCH TOUCH SCREEN",
            img: "/images/products/instrumentation/HMI-Touch-Screen.webp",
            desc: "PLC for Bag Making Machine which has 7 Inch Touch Screen HMI integrated on board.",
            pdfUrl: "/data/instrumentation/BAG-MAKING-PLC-WITH-SEVEN-INCH-TOUCH-SCREEN.pdf"
        },
        {
            name: "WIRELESS CRANE SCALE",
            img: "/images/products/instrumentation/wireless-crane.webp",
            desc: "Wireless Crane Scale which works with Zigbee wireless technology. It comes with Cortex M3 MCU.",
            pdfUrl: "/data/instrumentation/WIRELESS-CRANE-SCALE.pdf"
        },
        {
            name: "PROCESS WEIGHING INDICATOR",
            img: "/images/products/instrumentation/process-ind.webp",
            desc: "This product indicates weight as well as it contains two relay set points. It has tare and...",
            pdfUrl: "/data/instrumentation/PROCESS-WEIGHING-INDICATOR.pdf"
        },
        {
            name: "CIRCULAR CHART RECORDER",
            img: "/images/products/instrumentation/CIRCULAR-CHART-RECORDER.webp",
            desc: "Temperature controller and indicator is a very much important device which is widely used for...",
            pdfUrl: "/data/instrumentation/CIRCULAR-CHART-RECORDER.pdf"
        },
        {
            name: "FLOW AND LEVEL INDICATOR",
            img: "/images/products/instrumentation/FLOW-AND-LEVEL-INDICATORS.webp",
            desc: "This product is very useful in industries where the user wants to control flow or level. It has...",
            pdfUrl: "/data/instrumentation/FLOW-AND-LEVEL-INDICATOR.pdf"
        },
        {
            name: "INDUSTRIAL HEATERS",
            img: "/images/products/instrumentation/INDUSTRIAL-HEATERS.webp",
            desc: "These are electric heaters for industrial purposes. There are various shapes and sizes available.",
            pdfUrl: "/data/instrumentation/INDUSTRIAL-HEATERS.pdf"
        },
        {
            name: "TEMPERATURE SENSORS",
            img: "/images/products/instrumentation/TEMPERATURE-SENSORS.webp",
            desc: "It is used to measure current temperature with the help of sensor type mentioned by the user.",
            pdfUrl: "/data/instrumentation/TEMPERATURE-SENSORS.pdf"
        }
    ]
};

export const wirelessProductsPageData = {
    pageTitle: "Wireless",
    breadcrumbs: "Home > Products > Wireless",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "REAL-TIME CLOCK WITH GPS SYNCHRONIZATION",
            img: "/images/products/wireless/RTC1.webp",
            desc: "This product displays current time in synchronization with GPS Sattelite.",
            pdfUrl: "/data/wireless/REAL-TIME-CLOCK-WITH-GPS-SYNCHRONIZATION.pdf"
        }
    ]
};

export const laboratoryProductsPageData = {
    pageTitle: "Laboratory",
    breadcrumbs: "Home > Products > Laboratory",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "THERMAL PRINTER FOR WEIGHING SCALE",
            img: "/images/products/laboratory/Thermal-Printer.webp",
            desc: "A very efficient and compact Thermal Printer powered by ARM Cortex-M0 MCU.",
            pdfUrl: "/data/laboratory/THERMAL-PRINTER-FOR-WEIGHING-SCALE.pdf"
        },
        {
            name: "ANALYTICAL INSTRUMENTS",
            img: "/images/products/laboratory/Analytical-Instruments-1.webp",
            desc: "We Provide majority of the analytical checking and Measurement instruments. Please see below catalogue for more detail.",
            pdfUrl: "/data/laboratory/Analytical-Instruments.pdf"
        }
    ]
};

export const displayProductsPageData = {
    pageTitle: "Display",
    breadcrumbs: "Home > Products > Display",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "VARIABLE SIZE LED MATRIX & SCROLLING DISPLAYS",
            img: "/images/products/display/variable-display.webp",
            desc: "This product displays any programmed message in scrolling or static animations.",
            pdfUrl: "/data/display/VARIABLE-SIZE-LED-MATRIX-SCROLLING-DISPLAYS.pdf"
        }
    ]
};

export const microwaveMoistureSensorsProductsPageData = {
    pageTitle: "Microwave Moisture Sensors",
    breadcrumbs: "Home > Products > Microwave Moisture Sensors",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "BULK SOLIDS",
            img: "/images/products/microwave/JIOTRONIK-BULKSOLIDS.webp",
            desc: "Microwave moisture measurement sensor designed to be installed flush with the floor of a mixer, chute or conveyer in process control environments.",
            pdfUrl: "/data/microwave/JIOTRONIK-BULKSOLIDS.pdf"
        },
        {
            name: "CONCRETE AND CONSTRUCTION",
            img: "/images/products/microwave/CONCRETE-AND-CONSTRUCTION.webp",
            desc: "Sensor for accurately measuring the moisture content of materials flowing over the ceramic faceplate.",
            pdfUrl: "/data/microwave/CONCRETE-AND-CONSTRUCTION.pdf"
        }
    ]
};

export const xrayProductsPageData = {
    pageTitle: "X-Ray",
    breadcrumbs: "Home > Products > X-Ray",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "X-RAY PRESENTATION",
            img: "/images/products/xray/X_ray-Presentation.webp",
            desc: "We are pleased to introduce industrial applications of X-rays. Please see below Presentation and Applications attached below.",
            pdfUrl: "/data/xray/X_ray-Presentation.pdf"
        },
        {
            name: "X-RAY APPLICATIONS",
            img: "/images/products/xray/X_ray-Applications.webp",
            desc: "We are pleased to introduce industrial applications of X-rays. Please see below Presentation and Applications attached below.",
            pdfUrl: "/data/xray/X_ray-Applications.pdf"
        }
    ]
};

export const nirProductsPageData = {
    pageTitle: "NIR",
    breadcrumbs: "Home > Products > NIR",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    instruments: [
        {
            name: "NIR Jiotronik",
            img: "/images/products/nir/NIR-Jiotronik.webp",
            desc: "JIOTRONIK is Proud to introduce the latest technology with a greater number of data and lower bandwidth resolution empowered with high end 21CFR11 compliance operating software.",
            pdfUrl: "/data/nir/NIR-Jiotronik.pdf"
        },
        {
            name: "MicroNIR NIR",
            img: "/images/products/nir/MICRONIR-NIR.webp",
            desc: "JIOTRONIK is Proud to introduce the latest technology with a greater number of data and lower bandwidth resolution empowered with high end 21CFR11 compliance operating software.",
            pdfUrl: "/data/nir/MICRONIR-NIR.pdf"
        }
    ]
};

export const electricalProductsPageData = {
    pageTitle: "Electrical", // This can be dynamic if more categories are added
    breadcrumbs: "Home > Products > Electrical",
    introText: "Explore our comprehensive range of cutting-edge instrumentation and automation products, meticulously engineered for precision, durability, and seamless integration into your operations.",
    // This 'instruments' array now represents the specific items within the "Instrumentation & Automation" category
    instruments: [
        { name: "VARIABLE DC VOLTAGE SOURCE", 
            img: "/images/products/electrical/DC.webp", 
            desc: "It is built around the idea to exploit maximum functionality which can make Weighbridge operations effortless.", 
            pdfUrl: "/data/electrical/VARIABLE-DC-VOLTAGE-SOURCE.pdf" 
        },
        { name: "AUTOMATIC VOLTAGE REGULATOR", 
            img: "/images/products/electrical/AVR.webp", 
            desc: "An intelligent Active GPRS/GPS Remote Terminal Unit for robust M2M communications.", 
            pdfUrl: "/data/electrical/AUTOMATIC-VOLTAGE-REGULATOR.pdf" 
        },
        { name: "HIGH POWER STATIC STABILIZER", 
            img: "/images/products/electrical/SVAR.webp", 
            desc: "The product is Hook or Hanging scale,shows/indicates current weight applied on the Hook.", 
            pdfUrl: "/data/electrical/HIGH-POWER-STATIC-STABILIZER.pdf" 
        },
        { name: "ROTARY SWITCH TESTING MACHINE", 
            img: "/images/products/electrical/rotary.webp", 
            desc: "High-precision digital loadcell indicators and summing cards for various applications.", 
            pdfUrl: "/data/electrical/ROTARY-SWITCH-TESTING-MACHINE.pdf" 
        },
        { name: "SMART CHOPPER CONTROLLER", 
            img: "/images/products/electrical/chopper.webp", 
            desc: "Advanced PLC solutions with intuitive 7-inch touch HMI for bag making machinery.", 
            pdfUrl: "/data/electrical/SMART-CHOPPER-CONTROLLER.pdf" 
        },
        { name: "STATIC VARIAC SINE WAVE DIMMER", 
            img: "/images/products/electrical/SVAR (1).webp", 
            desc: "Robust wireless crane scales designed for heavy-duty lifting and safety.", 
            pdfUrl: "/data/electrical/STATIC-VARIAC-SINE-WAVE-DIMMER.pdf" 
        },
        { name: "ARM BASED SMART D.C. MOTOR DRIVES", 
            img: "/images/products/electrical/drive.webp", 
            desc: "Robust wireless crane scales designed for heavy-duty lifting and safety.",
            pdfUrl: "/data/electrical/ARM-BASED-SMART-D.C.-MOTOR-DRIVES.pdf" 
        },
        // Add other instruments as needed, following the same structure
    ]
};

export const softwarePageData = {
    pageTitle: "Software Solutions",
    breadcrumbs: "Home > Software",
    introText: "Leverage our expertise in software development to build robust, scalable, and custom solutions that cater to your specific business requirements and drive digital transformation across your enterprise.",
    services: [
        { name: "CMS DEVELOPMENT", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=CMS+Solutions", desc: "Bespoke CMS solutions, e-commerce platforms, and secure payment gateway integrations, backed by reliable support." },
        { name: "CORPORATE WEBSITE DEVELOPMENT", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=Corporate+Websites", desc: "Crafting professional corporate websites, engaging portfolio sites, custom portals, and robust enterprise platforms at competitive prices." },
        { name: "WEB SERVICES & API INTEGRATION", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=API+Integration", desc: "End-to-end API solutions: from development and deployment to continuous maintenance and seamless integration." },
        { name: "E-COMMERCE APPLICATION DEVELOPMENT", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=E-commerce+Apps", desc: "Developing feature-rich, high-performance online storefronts and e-commerce applications with extensive industry experience." },
        { name: "ENTERPRISE APPLICATION DEVELOPMENT", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=Enterprise+Software", desc: "Providing effective enterprise mobility platforms and custom applications to significantly enhance your business operations." },
        { name: "SINGLE PAGE APP (SPA) DEVELOPMENT", img: "https://placehold.co/400x250/D1D5DB/1F2937?text=SPA+Development", desc: "Expert SPA development for fast, responsive applications that improve user experience by eliminating page reloads." },
    ]
};

export const newsPageData = {
    pageTitle: "LATEST NEWS",
    breadcrumbs: "Home > News",
    news: [
        // {
        //     title: "AUTOMATED AND NON-CONTACT MOISTURE MEASUREMENT SYSTEM USING LIDAR/3D LASERPROFILING",
        //     date: "2024-06-15",
        //     subtitle: "JIOTRONIK NEWS UPDATE",
        //     details: [
        //         "JIOTRONIK is Pleased to inform that, Patent on “AUTOMATED AND NON-CONTACT MOISTURE MEASUREMENT SYSTEMS FROM VEHICLE LOAD VOLUME USING LiDAR/3D LASER/PROFILING SENSORS” was filed.",
        //         "Moisture determination is of prime important in majority of the products and material in industry. Moisture content is very critical in order to determine price to be paid to vendors, deciding quality of material, predicting shelf life of product/material, and effect of other constituents in the material due to moisture content.",
        //         "The conventional way of determining Moisture content of incoming and outgoing material from industry is through sampling process only. There is no technology / sensor (except Nuclear) available to determine Moisture content of the whole material when loaded on vehicle within short span of time.",
        //         "LiDAR/3D laser/Profiling sensors connected with Computer to calculate accurate volume of material on vehicle. OCR camera is used to identify the vehicle registration number. In this method end user will have accurate and repeatable results which will help them to accurately deciding price and quality of material. The results can be uploaded on cloud with geotagging, software can be equipped with feature that no alteration in the moisture reading is possible."
        //     ],
        //     ctaText: "WE ARE OPEN TO DISCUSS TECHNO-COMMERCIAL/JOINT VENTURE/EXCLUSIVE RIGHTS.",
        //     imageSrc: "/images/news.jpg",
        //     quote: "\"Let us go forward in the battle fortified by conviction that those who labour in the service of a great and good cause will never fail.\""
        // },
        {
            title: "AUTOMATED AND NON-CONTACT MOISTURE MEASUREMENT SYSTEM USING LIDAR/3D LASERPROFILING",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                "The present invention discloses an automatic and non-contact detection device for moisture content of a whole vehicle. The system consists of a LiDAR/3D laser/Profiling sensors connected with Computer to calculate accurate volume of material on vehicle. Electronic weighbridge is used to measure the weight of material loaded on the vehicle, based on difference of weight before and after unloading vehicle. OCR camera is used to identify the vehicle registration number, Oven and weigh scale is used to calculate dry weight of material. Based on system setup, without using any manual intervention system automatically calculates accurate Volume of material and weight. In this method end user will have accurate and repeatable results which will help them to accurately deciding price and quality of material. The results can be uploaded on cloud with geotagging, software can be equipped with feature that no alteration in the moisture reading is possible."
            ],
            imageSrc: "/images/news/Moisture-Patent.jpeg",
        },
        {
            title: "NEW ARTICLE PUBLISHED",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                "JIOTRONIK is pleased to share that an article, \"India’s Chip Leap Demands the Completion of the Ecosystem,\" has been published on the website of Electronics For You, India’s leading magazine in the field of embedded systems.",

                "You can read the article here:",
                "<a href=\"\">https://www.electronicsforu.com/technology-trends/india-chip-leap-demands-completion-ecosystem</a>",

                "I welcome comments and feedback from experts and professionals in this field."
            ],
            pdfUrl: "/data/news/electronicforu-article.pdf",
        },
        {
            title: "An article titled 'Smart Meter,' authored by Dr. Haresh Suthar, was published in divya bhaskar newspaper on May 21, 2024.",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                ""
            ],
            imageSrc: "/images/news/Divyabhaskar-Article.jpeg",
            imageStacked : 'bottom'
        },
        {
            title: "CAPACITANCE BASED LEVEL SENSOR",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                `JIOTRONIK is proud to announce the successful testing of our newly developed capacitance-based level sensor, designed for both liquid and solid applications, with a measuring range of up to 10 meters.
                We have conducted extensive testing using a minimum of 50 mm of diesel oil (with a dielectric constant <3), achieving an impressive resolution of 0.1 mm and a stable accuracy of ±1 mm — a level of performance currently unmatched in India for capacitance-based sensors.
                <br><br>
                <b>Key Features:</b><br>
                •	High-resolution measurement (0.1 mm) with ±1 mm accuracy<br>
                •	Temperature compensation and built-in temperature measurement<br>
                •	Adjustable filter lag for optimized response<br>
                •	Optional display for easy user calibration<br>
                •	Operates on 24V DC with low power consumption (<0.5A)<br>
                •	Integrated surge protection<br>
                •	Dual output: 4–20 mA and RS-485<br>
                •	Adjustable probe length and configurable zero/span<br>
                •	Fast response time: <1 second<br><br>
                <b>Applications:</b><br>
                Ideal for level measurement in oil tanks, plastics, food and feed industries, pharmaceuticals, dairy, agriculture, and more.
                We welcome inquiries for technical specifications and distributorship opportunities.
                Please connect with us to explore how JIOTRONIK can support your application needs.`
            ]
        },
        {
            title: "Unlock Higher Yield and Profitability with JIOTRONIK’s Moisture Measurement & Control Systems Solutions",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                `JIOTRONIK is excited to address a critical challenge faced by industries such as Food, Pharma, Dairy, Feed, and more—optimizing yield and profitability through accurate moisture measurement.
                <br><br>
                We have attached a presentation detailing how moisture measurement can significantly impact your company’s efficiency, yield, and profit margins. We encourage you to review the presentation to understand how our solutions can help you achieve measurable improvements.
                <br><br>
                If you recognize areas where your systems could benefit from enhanced moisture measurement, please don’t hesitate to reach out. We would be happy to discuss how JIOTRONIK can support your business goals.`
            ],
            pdfUrl: "/data/news/Moisture-Control-Variability-Jiotronik.pdf",
        },
        {
            title: "Customized Speed Sensors",
            date: "2024-06-15",
            subtitle: "JIOTRONIK NEWS UPDATE",
            details: [
                `JIOTRONIK is pleased to introduce Customized Speed Sensors for various applications and accuracy.
                <br><br>The major Applications area are as under:<br>
                1.	Pellet Mill control<br>
                2.	Feed Plant<br>
                3.	Dairy & Food Industry<br>
                4.	Pharma & Beverage Industry<br>
                5.	Poultry Industry<br>

                <br><br>
                It is perfect replacement to the imported Speed sensor with same quality and feature. 
                Please connect for any enquiry: sales@jiotronik.com
`
            ],
            imageSrc: "/images/news/Speed-Sensor.jpeg",
        },

    ]
};

export const knowledgeBasePageData = {
    pageTitle: "Knowledge Base",
    breadcrumbs: "Home > Knowledge Base",
    mainArticle: {
        title: "NIR Technology Complete Guide-Presentation",
        videoSrc: "https://youtu.be/RVUQ73aN0Ko?si=Wr4yKgXOpbleKeWz",
        topics: [
            "Introduction to Near-Infrared (NIR) Technology",
            "Working Principles and Spectrometer Designs",
            "Diverse Applications in Industrial Sectors",
            "Essential Calibration and Validation Procedures",
            "Comparative Advantages and Limitations"
        ],
        buttonText: "Download Presentation",
        pdfUrl: "/data/knowledge-base/Electrical-Energy-Basic-Concept.pdf"
    },
    articles: [
        {   title: "Understanding Sensor Principles in Measurement & Indication", 
            video: true, 
            videoSrc:"https://youtu.be/2p-hugvsEEY", 
            topics: ["Intro to Sensors", 
            "Sensor Types", 
            "Operating Mechanisms", 
            "Role in Accurate Measurement", 
            "Effective Indication Techniques"], 
            buttonText: "Download Resource",
            pdfUrl: "/data/knowledge-base/Electronics-Product-Design.pdf" 
        },
        { 
            title: "Online Network of PID Controllers & PPH Applications", 
            video: false, 
            summary: "Explore the architecture and industrial applications of networked PID controllers, focusing on PPH systems.", 
            buttonText: "Download Resource" 
        },
        { 
            title: "The Essence of Engineering Digital Design", 
            video: false, 
            summary: "Delve into the core concepts and best practices of modern digital design in engineering projects.", 
            buttonText: "Download Resource" 
        },
        {
            title: "Microwave Sensors Jiotronik",
            buttonText: "Download PDF",
            pdfUrl: "/data/knowledge-base/Microwave-Sensors-Jiotronik.pdf"
        },
        {
            title: "Moisture Control Variability Jiotronik",
            buttonText: "Download PDF",
            pdfUrl: "/data/knowledge-base/Moisture-Control-Variability-Jiotronik.pdf"
        },
        {
            title: "NIR Jiotronik",
            buttonText: "Download PDF",
            pdfUrl: "/data/knowledge-base/NIR-Jiotronik.pdf"
        },

        {
            title: "Understanding ADC Specifications",
            videoSrc: "https://www.youtube.com/watch?v=example3",
            topics: [
                "Resolution and accuracy",
                "Sampling rate",
                "Signal-to-noise ratio",
                "Conversion time"
            ],
            buttonText: "Download Guide",
            pdfUrl: "/data/knowledge-base/Understanding-Analog-To-Digital-Converter-Specifications.pdf"
        },
        {
            title: "Digital Design Essentials",
            videoSrc: "https://www.youtube.com/watch?v=example4",
            topics: [
                "Logic gates and circuits",
                "Boolean algebra",
                "Sequential logic",
                "State machines"
            ],
            buttonText: "Get Presentation",
            pdfUrl: "/data/knowledge-base/The-Essence-of-Engineering-Digital-Design.pdf"
        },
        {
            title: "PID Controllers in Industry",
            videoSrc: "https://www.youtube.com/watch?v=example5",
            topics: [
                "PID tuning methods",
                "Industrial applications",
                "Control system design",
                "Performance optimization"
            ],
            buttonText: "Download PDF",
            pdfUrl: "/data/knowledge-base/Design-Aspects-of-PID-Controllers-Its-Industrial-Applications.pdf"
        }
    ],
    sidebar: {
        questionsTitle: "Have Any Questions?",
        questionsText: "Our experts are ready to assist you. Reach out for any queries regarding our solutions or for technical support.",
        questionsButtonText: "Contact Our Experts",
        followTitle: "Follow Us"
    }
};

export const contactUsPageData = {
    pageTitle: "Contact Us",
    breadcrumbs: "Home > Contact Us",
    formTitle: "Get In Touch With Our Experts",
    mapImageSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.486734844447!2d73.12483739999999!3d22.2974245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc879946343bf%3A0x3e35f5306368cbb5!2sJIOTRONIK!5e0!3m2!1sen!2sin!4v1749565347689!5m2!1sen!2sin",
    contactPoints: [
        {icon: "🏢", title: "Our Office", detail: "SF/217, ARISTO, Near, Stone Gate, TP-2, BHAYLI, VADODARA, GUJARAT, INDIA"},
        {icon: "📞", title: "Our Phone", detail: "(+91) 9408028406"},
        {icon: "✉️", title: "Our Email", detail: "sales@jiotronik.com"},
        {icon: "🕒", title: "Working Hours", detail: "Mon - Fri: 10:00 am - 6:00 pm"}
    ]
};

export const footerData = {
    subscriptionTitle: "Subscribe & Get More Information",
    quickLinks: {
        title: "Quick Links",
        links: [
            { name: "Home", page: "home" }, { name: "About", page: "about" },
            { name: "FAQ", page: "#" }, { name: "Services", page: "#" }, 
            { name: "Contact", page: "contact" }
        ]
    },
    otherPages: {
        title: "Other Pages",
        links: [
            { name: "News", page: "news" },
            { name: "Knowledge Base", page: "knowledge" },
            //{ name: "Terms & Condition", page: "#" }
        ]
    },
    contactInfo: {
        title: "Contact Info",
        address: "SF/217, ARISTO, Near, Stone Gate, TP-2, BHAYLI, VADODARA, GUJARAT, INDIA",
        phone: "(+91) 9408028406",
        email: "sales@jiotronik.com",
        hours: "Mon - Fri : 10:00 am - 6:00 pm"
    },
    appointment: {
        title: "Make an Appointment",
        text: "Getting an accurate diagnosis can be one of the most impactful experiences that you can have.",
        buttonText: "Call Us Today",
        buttonLink: "contact"
    },
    copyrightText: "Jiotronik. All rights reserved. Crafted with ❤️."
};

export const whatsappData = {
    phoneNumber: '919408028406', // WhatsApp number with country code
    defaultMessage: 'Hello! I would like to know more about Jiotronik.'
};